import React from 'react';
import { Box, Grid, Stack, useMediaQuery } from '@mui/material';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import EirLoader from '../eir-loader/EirLoader';

const ActionModalCta = props => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={styles(theme).ctaBox}>
      {props.cta && props.cta.length > 0 && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 2, sm: 2, md: 2 }}
          sx={{ width: { xs: '100%' } }}
          justifyContent='center'
        >
          {props.cta.map((item, index) =>
            item.showLoader ? (
              <EirLoader
                loaderTitle={item.loaderText}
                buttonSize={sm ? { width: '100%' } : { width: '11.5rem', height: '2.6rem' }}
              />
            ) : (
              <Button
                key={index}
                onClick={item.action}
                type={item.type}
                disabled={props.disablecta || item.disable}
                variant='buttonMedium'
                aria-label={item?.ariaLabel}
                sx={item.type === 'solid' ? styles(theme).solidctastyle : styles(theme).ctastyle}
              >
                {item.text}
              </Button>
            )
          )}
        </Stack>
      )}
      {props?.altcta && props?.altcta?.length > 0 && (
        <Grid container columnSpacing={2} sx={styles(theme).altctaContainer}>
          {props.altcta.map((item, index) => (
            <Grid item key={index} xs={12} sm={6} sx={styles(theme).altctagrid}>
              <Button
                disabled={props.disablecta || item.disable}
                onClick={item.action}
                type={item.type}
                variant='altCta'
                sx={styles(theme).altctastyle}
              >
                <span style={{ color: theme.palette.primary.buttonColor, fontSize: '20px' }}>
                  {item.leftSubText}
                </span>
                {item.text}&nbsp;{' '}
                <span style={{ color: theme.palette.primary.buttonColor, fontSize: '20px' }}>
                  {item.subText}
                </span>
              </Button>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default ActionModalCta;
